<template>
    <tr class="licence__show_table_item_collapse_table_item">
        <td class="licence__show_table_item_collapse_table_item_blank"></td>
        <td class="licence__show_table_item_collapse_table_item_customer">
            {{ attemptDate }}
            <component-text :size="'small'">Time: {{ attemptTime }}</component-text>
        </td>
    </tr>
</template>

<script>
import { toLocaleDateTime, fromUTCDateTimeToLocalISOCustom } from '@/functions'
import ComponentText from '@/components/default/shared/ComponentText'

export default {
  name: 'licence-show-table-collapse-table-item',
  components: { ComponentText },
  props: {
    item: {
      type: String
    }
  },
  computed: {
    attemptDate () {
      return toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item))
    },
    attemptTime () {
      return toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item))
    }
  }
}
</script>
